import moment from "moment-timezone";

function createJsonGenerateOs(contract) {
  let OsRequestContract = {
    accredited: contract.accredited,
    numberPhone: contract.numberPhone,
    codeCity: contract.city.value,
    initialTime: contract.initialTime,
    conclusionTime: contract.conclusionTime,
    contractNumber: contract.contractNumber !== "" ? contract.contractNumber : "0",
    typeAttendance: contract.typeAttendance ?? 14, // Gerar os Type: 14
    serviceOutsideToa: contract.serviceOutsideToa ?? 0,
    dateStartedAttendance: contract.dateStartedAttendance ?? "",
    dateFinishedAttendance: moment().tz("America/Sao_Paulo").format("YYYY-MM-DD HH:mm:ss"),
    numberWo: contract.numberWo ?? "",
    urlLink: contract.urlLink ?? "",
    osRequests: contract.solicitations.map((item) => {
      if (Object.keys(item).includes("typeOS") && item.typeOS != null) {
        item.typeOS = item.typeOS.value;
      }

      if (
        Object.keys(item).includes("writeOffCode") &&
        item.writeOffCode != null
      ) {
        item.writeOffCode = item.writeOffCode.value;
      }

      return item;
    }),
  };
  const data = CreatedHourAndDates(OsRequestContract)
  return data
}

function CreatedHourAndDates(OsRequestContract) { // Id: ID do Time / Type: Primary ou Secundary

  const IdOptions1 = OsRequestContract.osRequests[0].hourOption1.id
  const IdOptions2 = OsRequestContract.osRequests[0].hourOption2.id
  const IdOptions3 = OsRequestContract.osRequests[0].hourOption3.id

  const DatePrimary = OsRequestContract.osRequests[0].option1
  const DateSecundary = OsRequestContract.osRequests[0].option2
  const dateTertiary = OsRequestContract.osRequests[0].option3

  if (DatePrimary) {
    OsRequestContract.osRequests[0].DatePrimary = DatePrimary
    OsRequestContract.osRequests[0].DateSecundary = DateSecundary
    OsRequestContract.osRequests[0].dateTertiary = dateTertiary

    delete OsRequestContract.osRequests[0].option1
    delete OsRequestContract.osRequests[0].option2
    delete OsRequestContract.osRequests[0].option3
  }

  if (IdOptions1) {
    OsRequestContract.osRequests[0].HourInitialPrimary = hours.find(hour => hour.id === IdOptions1)?.initialTime
    OsRequestContract.osRequests[0].HourFinishPrimary = hours.find(hour => hour.id === IdOptions1)?.finishTime

    delete OsRequestContract.osRequests[0].hourOption1

    OsRequestContract.osRequests[0].HourInitialSecundary = hours.find(hour => hour.id === IdOptions2)?.initialTime
    OsRequestContract.osRequests[0].HourFinishSecundary = hours.find(hour => hour.id === IdOptions2)?.finishTime
  
    delete OsRequestContract.osRequests[0].hourOption2

    OsRequestContract.osRequests[0].hourInitialTertiary = hours.find(hour => hour.id === IdOptions3)?.initialTime
    OsRequestContract.osRequests[0].hourFinishTertiary = hours.find(hour => hour.id === IdOptions3)?.finishTime

    delete OsRequestContract.osRequests[0].hourOption3
  }

  if(!OsRequestContract.initialTime && !OsRequestContract.conclusionTime){
    const startDate = OsRequestContract.dateStartedAttendance.split(' ')[1];
    const startHour = startDate.slice(0, 5);
    OsRequestContract.initialTime = startHour;
    OsRequestContract.conclusionTime = startHour;
  }


  return OsRequestContract
}

let hours = [
  {
    id: 1,
    initialTime: '08',
    finishTime: '12'
  },
  {
    id: 2,
    initialTime: '12',
    finishTime: '15'
  },
  {
    id: 3,
    initialTime: '15',
    finishTime: '18'
  }
]

export default createJsonGenerateOs;
